// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var ShoppingBag = function ShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.5 4.375V6.25h5V4.375c0-1.379-1.121-2.5-2.5-2.5a2.5 2.5 0 0 0-2.5 2.5m-1.875 3.75h-2.5v8.125c0 1.035.84 1.875 1.875 1.875h10c1.035 0 1.875-.84 1.875-1.875V8.125h-2.5v2.188c0 .519-.418.937-.937.937a.935.935 0 0 1-.938-.937V8.124h-5v2.188c0 .519-.418.937-.937.937a.935.935 0 0 1-.938-.937zm0-1.875V4.375A4.373 4.373 0 0 1 10 0a4.373 4.373 0 0 1 4.375 4.375V6.25h2.5c1.035 0 1.875.84 1.875 1.875v8.125c0 2.07-1.68 3.75-3.75 3.75H5c-2.07 0-3.75-1.68-3.75-3.75V8.125c0-1.035.84-1.875 1.875-1.875z"
  }));
};
